import src from "IMAGE";
export default { src, width: 1456, height: 403, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/AJuDYqWKZbWce495YIB0WXebRoeTVoZ3XwDCua2tp46quZaUiGiCbE1uXz2FdlaHcltsghgru3M63QAAAABJRU5ErkJggg=="};
